import { isObject } from 'api';

import { AutocompleteField, AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';
import { CountryType, countries } from './countries';

export type CountryAutocompleteProps = Omit<AutocompleteFieldProps<CountryType>, 'options'>;

export const CountryAutocompleteField = (props: CountryAutocompleteProps) => {
  return (
    <AutocompleteField<CountryType>
      options={countries}
      valueField="abbr"
      getOptionLabel={(option) => {
        if (isObject(option) && option?.name) {
          return option.name;
        }
        return '';
      }}
      data-testid="country-autocomplete"
      {...props}
    />
  );
};
